import moment from 'moment';
import { transformTimelogsToEvents } from './events';

// In-flight placeholders the user is still editing don't exist server-side yet and
// must survive any merge from the server.
const isLocalOnly = (ev) => ev.approval_status === 'Marked' || (ev.logId && String(ev.logId).startsWith('temp-'));

// Monday (ISO week) of the date, as the YYYY-MM-DD the week endpoint expects.
export const weekStartOf = (date) => moment(date).startOf('isoWeek').format('YYYY-MM-DD');

// Replaces everything in the given week with the fresh flat logs from /timelogs/week,
// so a log deleted elsewhere disappears too. Other weeks and local placeholders stay.
export function mergeWeekIntoEvents(prev, freshFlatLogs, weekStart) {
  const from = moment(weekStart, 'YYYY-MM-DD').startOf('day');
  const to = moment(from).add(7, 'days');
  const kept = prev.filter(ev => isLocalOnly(ev) || !moment(ev.start).isBetween(from, to, null, '[)'));
  return [...kept, ...transformTimelogsToEvents(freshFlatLogs)];
}

// One log pushed over SSE (timelog-upsert). A log CapLegal deleted transforms to
// nothing, which removes it, same as everywhere else.
export function upsertLogInEvents(prev, flatLog) {
  const [ev] = transformTimelogsToEvents([flatLog]);
  const rest = prev.filter(e => e.logId !== flatLog.id);
  return ev ? [...rest, ev] : rest;
}

// timelog-removed
export function removeLogFromEvents(prev, id) {
  return prev.filter(e => e.logId !== id);
}
